module.exports = __webpack_public_path__ + "img/yanbao_nongchanpin_foot.f38e5857.png";